import * as React from 'react';
import { connect } from 'react-redux';
import './Initial.css';
import { MOBILE_MAX_WIDTH } from '../../../../utils';
import MediaQuery from 'react-responsive';

interface Props {
	onClickCard: () => void;
}

const Initial: React.FunctionComponent<Props> = props => {
	return <div className="initial-find">
		<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
			<div className="initital_mobile">
				Введите название книги или имя автора
			</div>
		</MediaQuery>
	</div>
};

export default connect()(Initial);
